import { defineStore } from 'pinia'

export const RightDrawer = defineStore({
    id: 'wp_drawer_r',
    state: () => {
        return { value: null }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})

export const LeftDrawer = defineStore({
    id: 'wp_drawer_l',
    state: () => {
        return { value: null }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})

export const LoadedWeeks = defineStore({
    id: 'wp_weeks_loaded',
    state: () => {
        return { value: [] }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})

export const Observers = defineStore({
    id: 'wp_observers',
    state: () => {
        return { value: [] }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})

export const DuplicatingEvent = defineStore({
    id: 'wp_event_duplicating',
    state: () => {
        return { value: null }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})
